export var PageChangeEventType;
(function (PageChangeEventType) {
  PageChangeEventType["First"] = "first";
  PageChangeEventType["Previous"] = "previous";
  PageChangeEventType["Next"] = "next";
  PageChangeEventType["Last"] = "last";
})(PageChangeEventType || (PageChangeEventType = {}));
//# sourceMappingURL=types.js.map
